VP = window.VP || {};

/*
 * Page Load Modifers
*/

(function( $ ) {
  VP.brewSort = {
    hasdayfilter:false,
    nearmesort:false, // differntiate between beer sorting and near me article sorting
    buildtimer:null,
    hasuserlocation:false,
    userlat:"",
    userlng:"",
    loadsort:true,
    enabled:false,
    datamax:"9999999",
    locationName: "your current location",
    allitems:".vp-story__item[data-type='article-section'],.vp-story__item[data-type='breaker']",
    brewitem:".vp-story__item[data-type='article-section']",
    breakeritems:".vp-story__item[data-type='breaker']",
    startdivs:null,
    startdata:null,
    startitems:null,

    init: function () {

      var _this = VP.brewSort;

      if ($(".vp-intro__content .vp-note").length == 1) {
        $("body").addClass("hasNote");
      }

      _this.hasdayfilter = ($(".dayfilter").length > 0)

      // include brew sort for near me
      if ($(_this.brewitem+"[data-rating]").length == 0 && $(".vp-nearmesort").length == 0) {
        // console.log("no [brewsort]")
        return;
      }

      if ($(".vp-nearmesort").length) {
        _this.nearmesort = true;
        $("body").addClass("hasSortNear");
      }

      $("body").addClass("hasBrewSort");

      _this.enabled = true;

      //console.log("[brewsort] init (queued)");
      //VP.documentEvents.onDelayInit( );
      // console.log("[brewsort] init now");      
      VP.brewSort.delayedinit();

    },
    delayedinit: function() {
      // console.log("[brewsort] execute delayed init");
      var _this = VP.brewSort;

      $(_this.brewitem).each(function() {
        r = $(this).attr("data-rating");
        if (isNaN(r) || r == "") {
           $(this).attr("data-rating",0);
        }
      });

      $(_this.allitems).wrapAll("<div class='vp-sectioncontainer'></div>");

      _this.startdivs = $(".vp-sectioncontainer").html();
      _this.startdata = VP_storyTracker_data;
      _this.startitems = $(".vp-story-tracker__items").html();

      buttonhtml = '<div class="vp-sortholder vp-wrapper"><div class="vp-sortbuttons"><div class="vp-sortinner vp-wrapinner"><label>Sort by:</label>';
      buttonhtml += '<a href="javascript:;" class="vp-btn brewsort sortrating" data-sort="rating">Rating</a>';
      buttonhtml += '<a href="javascript:;" class="vp-btn brewsort sortname" data-sort="az">Name A-Z</a>';
      buttonhtml += '<a href="javascript:;" class="vp-btn brewsort sortnear" data-sort="near">Near Me</a>';
      buttonhtml += '</div></div>';
      buttonhtml += '<div class="vp-untappd"><div class="vp-wrapinner"><a class="taplink" href="https://untappd.com/business/breweries" target="_blank">Ratings powered by <span class="untappdlogo">Untappd</span></a></div></div>';
      buttonhtml += '</div>';

      if (_this.hasdayfilter) {
        // TODO: insert into day filter

        $(".vp-daywrap").append('<a href="javascript:;" class="vp-btn brewsort sortnear" data-sort="near">Sort by Near Me</a>');
      }
      else {
         //$(".vp-intro").append(buttonhtml);
         $(".vp-story__item").first().before(buttonhtml);
      }

      // SORTING BUTTONS CLICK
      $(".brewsort").on("click",function() {

        // normally, an active click does nothing, except on nearme only sorting
        if ($(this).hasClass("vp-active")) {
          
          // revert sorting, there is only one button to click for near
          if (_this.nearmesort) {
            $(this).removeClass("vp-active");
            _this.brewsort("start");
            // sort back to original 
            var addoffset = 0;
            // sort buttons overlay the positioning
            if (!$(".vp-sortbuttons").hasClass("fixed") ) {
              if (VP.helpers.isDesktopSize()) {
                addoffset = -59;
              }
              else {
                addoffset = -55;
              }
            }
            setTimeout(function() {
              // add delay for hiding breakers and quicklinks
              VP.storyTracker.scrollToItem(1, false, addoffset);
              VP.quicklinks.init();
              VP.iglazy.loadFirstItem();
            },500);
          }
          return;
        }
        $(".brewsort").removeClass("vp-active");
        $(this).addClass("vp-active");
        _this.brewsort($(this).data("sort"));

        if ( !_this.loadsort ) {
          var addoffset = 0;
          // sort buttons overlay the positioning
          if (!$(".vp-sortbuttons").hasClass("fixed") ) {
            if (VP.helpers.isDesktopSize()) {
              addoffset = -59;
            }
            else {
              addoffset = -55;
            }
          }
          setTimeout(function() {
            // add delay for hiding breakers and quicklinks
            VP.storyTracker.scrollToItem(1, false, addoffset);
          },200);
          
        }
      });

      $(".vp-story__item .vp-ads-465-wrapper,.vp-story__item .vp-ads-300-wrapper").each(function() {
          val = $(this).parent().data("value");
          $(this).attr("data-location",val);
      });

      // SORT ON INIT
      if (!_this.nearmesort) {
        var sort = VP.helpers.getQParams("sort");
        if (sort == "none") {
        }
        else if(sort == "az" || sort == "name") {
          $('.sortname').trigger("click");
        }
        else {
          $('.sortrating').trigger("click");
        }
      }
      _this.loadsort = false;

      _this.eventHandlers();
  
    },
    getuserlocation:function() {
      // check storytracker for location
      if (VP.storyTracker.hasuserlocation) {
        VP.brewSort.locationSuccess(VP.storyTracker.userpos);
      }
      else {
        VP.helpers.location(VP.brewSort.locationSuccess,VP.brewSort.locationFailure);
      }
    },
    locationSuccess: function(position) {
      var _this = VP.brewSort;
      _this.userlat =  position.coords.latitude;
      _this.userlng =  position.coords.longitude;
      // console.log("Found Location at: " + _this.userlat + "," + _this.userlng);
      _this.hasuserlocation = true;      
      _this.brewsort("near");
      VP.storyTracker.addUserLocation(_this.userlat,_this.userlng);
    },
    locationFailure: function(error_message) {
      var _this = VP.brewSort;
      console.error('An error has occured while retrieving location', error_message);
      alert("VisitPhilly.com was unable to access your location. Philadelphia City Hall will be used as the default location.");
      _this.userlat =  "39.952583";
      _this.userlng = "-75.165222";
      _this.hasuserlocation = true;
      _this.locationName = "Philadelphia City Hall";
      _this.brewsort("near");
      VP.storyTracker.addUserLocation(_this.userlat,_this.userlng);
    },
    brewsort: function(sorttype) {
      var _this = this;
      // console.log("[brewsort] RUNNING SORT: " + sorttype);

      // sort main divs
      $divs = $(_this.brewitem);

      if (sorttype == "start") {         // unsort, return to beggining
        $("body").removeClass("sortrating").removeClass("sortnear").removeClass("sortaz");
        $(".vp-sectioncontainer").html(_this.startdivs);
        VP_storyTracker_data = _this.startdata;
        $(".vp-story-tracker__items").html(_this.startitems);
        $(".vp-article-section, .vp-article-breaker").removeClass("js-reveal").removeClass("js-reveal--enabled");
        VP.helpers.forceAdRefresh($(".vp-story-tracker-module__wrapper"));
        VP.storyTracker.update();
         
        setTimeout(function() {
          $(".vp-story-tracker__item--active").removeClass("vp-story-tracker__item--active");
          $(".vp-story-tracker__items--has-active").removeClass("vp-story-tracker__items--has-active");
    
          $(".vp-story-tracker__breaker--active").removeClass("vp-story-tracker__breaker--active"); 
          $(".vp-story-tracker__breaker--selected").removeClass("vp-story-tracker__breaker--selected");

        },100);
        return;
      }

      // GET LOCATION AND SET DISTANCE
      if (sorttype == "near") {

        if (!_this.hasuserlocation) {
          _this.getuserlocation();
          return;
        }
        else {

          // GET USER LAT/LNG
          userlat = _this.userlat;
          userlng = _this.userlng;
        //  userlat = "39.952583";
        //  userlng = "-75.165222";

          // set distance values
          $(".distancedetails").remove();
          $divs.each(function() {
            if (isNaN($(this).data("lat")) ||  isNaN($(this).data("lng"))) {
              $(this).attr("data-dist",_this.datamax);
              // console.log("SET MAX");
            }
            else {
              var _dist = VP.helpers.distance(userlat, userlng, $(this).data("lat"),$(this).data("lng"));
              // console.log("SET DIST ");
              $(this).attr("data-dist",_dist);
              // console.log($(this));
              // console.log(_dist);
              $itemdetails = $(this).find(".vp-article-section__detail-item");
              $itemdetails.first().after("<p class=\"vp-article-section__detail-item distancedetails\"><strong>Distance: </strong> " + VP.helpers.round(_dist,2) + " miles from " + _this.locationName + "</p>");
            }
          });

          $.each(VP_storyTracker_data,function(i,d) {
              d.dist  =VP.helpers.distance(userlat, userlng, d.lat,d.lng);
          });

          $(".vp-story-tracker__item").each(function() {
            var _dist = VP.helpers.distance(userlat, userlng, $(this).data("lat"),$(this).data("lng"));
            //console.log($(this));
            //console.log(_dist);
            $(this).attr("data-dist",_dist);
            if ( VP.helpers.debug ) {
              $(this).append(VP.helpers.round(_dist,2));
            }
          });
        }
      }

      // remove breakers
      $(".breakeritems").remove();


      $sorteddivs = $divs.sort(function (a, b) {
        if (sorttype == "rating") {
          condition = $(a).data("rating") < $(b).data("rating");
          $("body").addClass("sortrating").removeClass("sortnear").removeClass("sortaz");
        }
        if (sorttype == "az") {
         condition = $.trim($(a).find("h2").text()) > $.trim($(b).find("h2").text());
         $("body").addClass("sortaz").removeClass("sortrating").removeClass("sortnear");
        }
        if (sorttype == "near") {
        condition = $(a).data("dist") > $(b).data("dist");
         $("body").addClass("sortnear").removeClass("sortrating").removeClass("sortaz");
        }
        if (condition) {
          return 1;
        }
        else {
          return -1;
        }
      });
      $(".vp-sectioncontainer").html($sorteddivs);
      $(".vp-article-section").removeClass("js-reveal").removeClass("js-reveal--enabled");

      // sort javascript array
      if (sorttype == "rating") {
        VP_storyTracker_data.sort(function(x, y) {
          if (x.rating < y.rating) {
            return 1;
          }
          return -1;
        });
      }
      if (sorttype == "az") {
        VP_storyTracker_data.sort(function(x, y) {
          if (x.name < y.name) {
            return -1;
          }
          return 1;
        });
      }
      if (sorttype == "near") {
        VP_storyTracker_data.sort(function(x, y) {
          if (x.dist > y.dist) {
            return 1;
          }
          return -1;
        });
      }

      // sort story tracker items
      $divs = $(".vp-story-tracker__item");
      $sorteddivs = $divs.sort(function (a, b) {
        if (sorttype == "rating") {
          condition = $(a).data("rating") < $(b).data("rating");
        }
        if (sorttype == "az") {
         //condition = $.trim($(a).find("a").text()) > $.trim($(b).find("a").text());
         condition = $.trim($(a).data("name")) > $.trim($(b).data("name"));

        }
        if (sorttype == "near") {
          condition = $(a).data("dist") > $(b).data("dist");
        }
        if (condition) {
          return 1;
        }
        else {
          return -1;
        }
      });
      $(".vp-story-tracker__items").html($sorteddivs);




      // renumber everything after sort
      $(".vp-story-tracker__item").each(function(i,j) {
        val = i+1;
        $(this).attr("data-item-no",val);
      });


      $(_this.brewitem).each(function(i,j) {
        val = i+1;
        zeroval = val;
        if (val < 10) {
          zeroval = "0"+val;
        }

        $(this).find(".vp-article-section__counter span").text(zeroval);
        $(this).attr("data-value",val);
        $(this).attr("data-url","#vp-article-section--item-"+val);
        $as = $(this).find(".vp-article-section");
        $as.attr("id","vp-article-section--item-"+val);
        $as.attr("data-item-no",val);
      });

      // reposition ads
      $(_this.brewitem+" .vp-ads-465-wrapper,"+_this.brewitem+" .vp-ads-300-wrapper").each(function() {
        loc = $(this).data("location");
        $place = $(".vp-story__item[data-value='"+loc+"']");
        if ($place.length == 1) {
          $(this).appendTo($place);
        }
      });


      
      VP.modifiers.relatedfirst();



      if (VP.storyTracker) {
        VP.storyTracker.rebuildMap();
        clearTimeout(_this.buildtimer);
        
          setTimeout(function() {
            //$(".vp-story-tracker__item--active").removeClass("vp-story-tracker__item--active");
            //$(".vp-story-tracker__items--has-active").removeClass("vp-story-tracker__items--has-active");
         
            $(".vp-story-tracker__breaker--active").removeClass("vp-story-tracker__breaker--active"); 
            $(".vp-story-tracker__breaker--selected").removeClass("vp-story-tracker__breaker--selected");
  
          },100);
            
        // _this.buildtimer = setTimeout(function() {
        //   console.log("rebuild waypoints");
        //   VP.storyTracker.waypointsInit(); }
        //   ,3000);
          
      }

      setTimeout(function() {
        VP.helpers.forceAdRefresh($(".vp-story-tracker-module__wrapper"));
      },1000);

      setTimeout(function() {
        VP.helpers.checkAdRefresh( false );
      },3000);



    },

    checkScrollPosition: function() {
      var _this = this;
      if (_this.hasdayfilter) {
        return;
      }
      var windowTop = $( window ).scrollTop();
      var $sholder = $(".vp-sortholder");
      var $sbuttons = $(".vp-sortbuttons");
      var sortTop = $sholder.offset().top;
      var navHeight = $(".vp-header").height();
      var fixnav = windowTop + navHeight > sortTop;

      // for nearme only fix nav if sorted
      if (_this.nearmesort) {
        fixnav =  fixnav && $("body").hasClass("sortnear");
      }

      if (VP.storyTracker.expanded) {
        fixnav = true;
      }

      if (fixnav) {
          //$sbuttons.removeClass("fixed");
          if (!$sbuttons.hasClass("fixed")) {
            $sholder.height($sholder.height());
            $sbuttons.addClass("fixed");
          }

          // manually adjust position
          if ($(window).width() > 600) {
            $(".vp-sortinner").css("marginLeft",$(".vp-header__logo").offset().left);
          }
          else {
            $(".vp-sortinner").css("marginLeft","");
          }
          if ( VP.helpers.isDesktopSize() || VP.storyTracker.expanded) {
            $sbuttons.removeClass("bottom").addClass("top");
            $sbuttons.data("position","top");
            if ($(".quicklinks").length) {
              navHeight +=$(".quicklinks").height() -1;
            }
            $sbuttons.css("top",navHeight);
            $sbuttons.css("bottom","");
          }
          else {
            $sbuttons.addClass("bottom").removeClass("top");
            $sbuttons.css("bottom",-1);
            $sbuttons.css("top","inherit");
          }

      }
      else {
          $sbuttons.removeClass("bottom").removeClass("top");
          $(".vp-sortinner").css("marginLeft","");

          $sbuttons.removeClass("fixed");
          $sholder.height($sholder.height("auto"));

          $sbuttons.css("top","");
          $sbuttons.css("bottom","");

      }


      $st = $(".vp-story-tracker-module--docked");
      if ($st.length == 1) {
        var pos = "";
        if ($sbuttons.hasClass("fixed top")) {
          pos = $sbuttons.height() + VP.nav.wrapper.height();
        }

        /// CONFLICT WITH EXPANDED MAP
        if (!VP.storyTracker.expanded) {
          $st.css("top",pos);
        }
      }
    },
    eventHandlers: function() {
      var _this = this;
      VP.helpers.detectMobile();

      VP.documentEvents.onResize( _this.checkScrollPosition.bind( _this ), true );
      VP.documentEvents.onScroll( _this.checkScrollPosition.bind( _this ), true );
      setTimeout(function() {
        _this.checkScrollPosition();
      },500);


    }
  };
})(jQuery);
